<template>
    <div class="button" :style="cssStyle" @click="$emit('click')">
        <slot />
    </div>
</template>

<script>
import Mixins from '@/mixins/Button';

export default {
    mixins: [Mixins],
};
</script>

<style lang="scss" scoped>
.button {
    cursor: pointer;
    border-radius: 49.3px;
    display: flex;
    width: 80%;
    height: 100%;
    @media screen and (max-width: 374px) {
        width: 90%;
    }
}
</style>
